import React from "react";
import "./CommonScenariosSection.css";

const CommonScenariosSection = () => {
  return (
    <section className="_cSect_q1A_">
      <div className="_cSCont_r2B_">
        <h2 className="_sTitle_s3C_" style={{paddingBottom:"1.3rem",marginBottom:"1.8rem"}}>Handling Common Scenarios</h2>
        <div className="_sGrid_t4C_">
          <div className="feature-item _sCard_u5D_">
            <h4 className="_sCTitle_v6E_" style={{textAlign:"left"}}>
              Order Problem (Damaged/Not Received)
            </h4>
            <ul className="_sCList_w7F_">
              <li>Acknowledge the issue calmly.</li>
              <li>Request photo (if damaged) & order number.</li>
              <li>Commit to review & update within 2 hours.</li>
            </ul>
            <p className="_gRule_x8G_">
              <span>Golden Rule:</span> Prioritize empathy and quick information
              gathering.
            </p>
          </div>

          <div className="feature-item _sCard_u5D_">
            <h4 className="_sCTitle_v6E_" style={{textAlign:"left"}}>Refund or Payment Delay</h4>
            <ul className="_sCList_w7F_">
              <li>Thank user for patience.</li>
              <li>Confirm approval date (if known).</li>
              <li>Explain standard processing time (2–5 business days).</li>
              <li>Promise status confirmation soon.</li>
            </ul>
            <p className="_gRule_x8G_">
              <span>Golden Rule:</span> Manage expectations with clear
              timelines.
            </p>
          </div>

          <div className="feature-item _sCard_u5D_">
            <h4 className="_sCTitle_v6E_" style={{textAlign:"left"}}>Escalation Request</h4>
            <ul className="_sCList_w7F_">
              <li>Acknowledge details shared.</li>
              <li>Confirm immediate escalation to manager.</li>
              <li>Commit to a response within 24 hours.</li>
            </ul>
            <p className="_gRule_x8G_">
              <span>Golden Rule:</span> Provide clear next steps and timelines
              for resolution.
            </p>
          </div>

          <div className="feature-item _sCard_u5D_">
            <h4 className="_sCTitle_v6E_" style={{textAlign:"left"}}>Difficult/Angry User</h4>
            <ul className="_sCList_w7F_">
              <li>Validate their frustration.</li>
              <li>Express willingness to help.</li>
              <li>Invite collaborative problem-solving.</li>
            </ul>
            <p className="_gRule_x8G_">
              <span>Golden Rule:</span> Lead with empathy, then pivot to
              resolution.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CommonScenariosSection;
